class StepNavigationController {
  constructor(orchestrator) {
    this.orchestrator = orchestrator;
  }

  getActiveStepKey() {
    const active = this.orchestrator.dom.modal.querySelector(
      '.customizer-sidebar .steps [data-content-step].active',
    );
    return active?.dataset.contentStep || 'arts';
  }

  canNavigateToTexts() {
    return this.orchestrator.artAllowsText(
      this.orchestrator.selectionState.getSelectedArt(),
    );
  }

  canNavigateToFinish() {
    const { selectionState } = this.orchestrator;
    return (
      Boolean(selectionState.getSelectedArt()) ||
      Boolean(selectionState.customText.trim())
    );
  }

  getNextStepKey(currentStep = this.getActiveStepKey()) {
    if (currentStep === 'arts') {
      if (this.canNavigateToTexts()) return 'texts';
      return this.canNavigateToFinish() ? 'finish' : null;
    }
    if (currentStep === 'texts') {
      return 'finish';
    }
    return null;
  }

  syncStepNavAvailability() {
    const { navSteps } = this.orchestrator.dom;
    const textsEnabled = this.canNavigateToTexts();
    const finishEnabled = this.canNavigateToFinish();

    navSteps.forEach(button => {
      const step = button.dataset.navStep;
      if (step === 'texts') {
        button.disabled = !textsEnabled;
        button.classList.toggle('disabled', !textsEnabled);
        button.setAttribute('aria-disabled', textsEnabled ? 'false' : 'true');
        return;
      }
      if (step === 'finish') {
        button.disabled = !finishEnabled;
        button.classList.toggle('disabled', !finishEnabled);
        button.setAttribute('aria-disabled', finishEnabled ? 'false' : 'true');
      }
    });
  }

  syncNextStepButton() {
    const { btnNextStep, finishAddCartBtn, finishCheckoutQrBtn } =
      this.orchestrator.dom;
    if (!btnNextStep) return;

    const currentStep = this.getActiveStepKey();
    const nextStep = this.getNextStepKey(currentStep);
    const isFinish = currentStep === 'finish';
    btnNextStep.textContent = 'Próximo';

    if (finishAddCartBtn) {
      finishAddCartBtn.hidden = !isFinish;
    }
    if (finishCheckoutQrBtn) {
      finishCheckoutQrBtn.hidden = !isFinish;
    }

    if (isFinish || !nextStep) {
      btnNextStep.hidden = true;
      btnNextStep.disabled = true;
      btnNextStep.classList.add('disabled');
      return;
    }

    btnNextStep.hidden = false;

    const shouldDisable =
      currentStep === 'texts' ? !this.canNavigateToFinish() : false;
    btnNextStep.disabled = shouldDisable;
    btnNextStep.classList.toggle('disabled', shouldDisable);
    btnNextStep.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
  }

  setActiveStep(stepKey) {
    const { navSteps, contentSteps } = this.orchestrator.dom;
    if (!stepKey) return;
    if (stepKey === 'texts' && !this.canNavigateToTexts()) return;
    if (stepKey === 'finish' && !this.canNavigateToFinish()) return;

    navSteps.forEach(button => {
      button.classList.toggle('active', button.dataset.navStep === stepKey);
    });

    contentSteps.forEach(panel => {
      panel.classList.toggle('active', panel.dataset.contentStep === stepKey);
    });

    if (stepKey === 'finish') {
      this.orchestrator.finishCheckoutController.syncFinishStep();
    }

    this.syncStepNavAvailability();
    this.syncNextStepButton();
  }

  initialize() {
    const { modal, navSteps, btnNextStep } = this.orchestrator.dom;
    if (modal.dataset.stepsReady === 'true') return;
    modal.dataset.stepsReady = 'true';

    navSteps.forEach(button => {
      button.addEventListener('click', () => {
        if (button.disabled || button.classList.contains('disabled')) return;
        this.setActiveStep(button.dataset.navStep);
      });
    });

    if (btnNextStep) {
      btnNextStep.addEventListener('click', () => {
        if (
          btnNextStep.disabled ||
          btnNextStep.classList.contains('disabled')
        ) {
          return;
        }
        const nextStep = this.getNextStepKey();
        if (nextStep) this.setActiveStep(nextStep);
      });
    }

    this.syncStepNavAvailability();
    this.syncNextStepButton();
  }
}

window.StepNavigationController = StepNavigationController;
